import { PropsWithChildren } from 'react';
import { CircleSize, StyledCircle } from './styles';

export interface CircledIconProps extends PropsWithChildren {
  size?: keyof typeof CircleSize;
  opacity?: number;
  backgroundRGBColor?: string;
  color?: string;
}

export default function CircledIcon(props: CircledIconProps) {
  const {
    size = CircleSize.medium,
    opacity = 1,
    backgroundRGBColor = 'var(--payment-palette-neutral-0-rgb)',
    color = 'var(--payment-palette-neutral-900)',
    children,
    ...iconProps
  } = props;

  return (
    <StyledCircle
      size={size}
      opacity={opacity}
      backgroundRGBColor={backgroundRGBColor}
      color={color}
      {...iconProps}
    >
      {children}
    </StyledCircle>
  );
}
